import React, { createContext, useContext, useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

import { tokenStorage } from "../utils/storage";
import { SOCKET_URL } from "../config/env";

interface SocketContextProps {
  socket: Socket | null;
}

const SocketContext = createContext<SocketContextProps>({ socket: null });

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [token, setToken] = useState<string | null>(tokenStorage.get());

  useEffect(() => {
    const checkToken = () => {
      const currentToken = tokenStorage.get();
      if (currentToken !== token) {
        setToken(currentToken);
      }
    };
    const interval = setInterval(checkToken, 500);

    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    if (socket) {
      socket.disconnect();
      setSocket(null);
    }
    if (!token) return;

    const newSocket = io(`${SOCKET_URL}/notifications`, {
      auth: { token },
      transports: ["websocket"],
      reconnection: true,
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
    // eslint-disable-next-line
  }, [token]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
